import { __assign, __extends } from "tslib";
import React, { Component } from 'react';
import { View, Image } from 'react-native';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PnmacMeta, PnmacPageBubble, PnmacText } from 'pnmac-universal-components';
import moments from 'moment';
var PaymentAch = /** @class */function (_super) {
  __extends(PaymentAch, _super);
  function PaymentAch(props) {
    return _super.call(this, props) || this;
  }
  PaymentAch.prototype.render = function () {
    var translations = this.props.translations;
    return /*#__PURE__*/React.createElement(View, {
      id: "main-content",
      className: "container px-5 pb-5 pt-4"
    }, /*#__PURE__*/React.createElement(PnmacMeta, {
      title: translations.automaticPayments
    }), /*#__PURE__*/React.createElement(PnmacPageBubble, {
      accessibilityRole: "header",
      ariaLevel: "1",
      text: translations.automaticPayments
    }), /*#__PURE__*/React.createElement(PnmacText, null, translations.AutoPayApplicationSentOn, " ", moments().format("MM/DD/YYYY")), /*#__PURE__*/React.createElement(PnmacText, null, translations.AchSuccessPaperlessMsg1), /*#__PURE__*/React.createElement(PnmacText, null, translations.AchPendingImportantInformation), /*#__PURE__*/React.createElement(PnmacText, null, translations.AchPendingImpInfoMsg1), /*#__PURE__*/React.createElement(PnmacText, null, translations.AchPendingImpInfoMsg2), /*#__PURE__*/React.createElement(PnmacText, null, translations.AchPendingImpInfoMsg3));
  };
  return PaymentAch;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  var Actions = require("../redux/actions/actions.js");
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(PaymentAch);